import { render } from "./DisplayVideo.vue?vue&type=template&id=1652a7d3&scoped=true&ts=true"
import script from "./DisplayVideo.vue?vue&type=script&lang=ts"
export * from "./DisplayVideo.vue?vue&type=script&lang=ts"

import "./DisplayVideo.vue?vue&type=style&index=0&id=1652a7d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1652a7d3"]])

export default __exports__